var _circle, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _polygon, _polygon2, _polygon3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path10, _path11, _path12, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.12845,
    height: 482.02689,
    viewBox: "0 0 297.12845 482.02689",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.91978,
    cy: 211.41531,
    r: 42.6161,
    fill: "#ff4d4d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.709,524.0992a5.579,5.579,0,0,1-3.1598-4.73262l-.61994-11.73594a5.57974,5.57974,0,0,1,5.2721-5.86037l97.81656-5.16738a5.57976,5.57976,0,0,1,5.86028,5.27184l.62,11.73638a5.57991,5.57991,0,0,1-5.27193,5.86l-97.81673,5.16772A5.54053,5.54053,0,0,1,492.709,524.0992Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ff4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M560.13939,524.32911a5.59052,5.59052,0,0,1-3.15683-5.06985l-.11594-22.09664a5.57333,5.57333,0,0,1,5.62009-5.53255l44.624,3.934c1.18124.00715,2.67235,1.83722,3.87112,3.30626.376.4612.70069.85938.93814,1.10039.10406.10569.20314.21546.29721.32756h0a5.56419,5.56419,0,0,1,1.30236,3.62807l-.09769,11.75154a5.58085,5.58085,0,0,1-5.62034,5.52769l-45.25677,3.67276A5.62041,5.62041,0,0,1,560.13939,524.32911Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M588.04814,691.01345H576.29566a5.5802,5.5802,0,0,1-5.57394-5.574V585.89393a5.5802,5.5802,0,0,1,5.57394-5.57395h11.75248a5.58021,5.58021,0,0,1,5.57395,5.57395V685.4395A5.58021,5.58021,0,0,1,588.04814,691.01345Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ff4d4d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M619.04814,691.01345H607.29566a5.5802,5.5802,0,0,1-5.57394-5.574V585.89393a5.5802,5.5802,0,0,1,5.57394-5.57395h11.75248a5.58021,5.58021,0,0,1,5.57395,5.57395V685.4395A5.58021,5.58021,0,0,1,619.04814,691.01345Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ff4d4d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M602.02859,436.19681l.04432-1.59255c-2.96271-.08243-5.57472-.26828-7.53742-1.7022a4.89549,4.89549,0,0,1-1.89621-3.6058,2.79839,2.79839,0,0,1,.918-2.30485c1.30289-1.10033,3.39934-.74418,4.92736-.04355l1.31767.60421-2.52686-18.466-1.57778.21618,2.14932,15.70782a5.62168,5.62168,0,0,0-5.31772.76517,4.35642,4.35642,0,0,0-1.48135,3.577,6.47583,6.47583,0,0,0,2.54824,4.836C596.11794,436.03118,599.39519,436.12294,602.02859,436.19681Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.88179,
    y: 201.67028,
    width: 8.57709,
    height: 1.59256,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.95523,
    y: 201.67028,
    width: 8.57709,
    height: 1.59256,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M644.90736,562.32531l-39.33447-78.43817h.55468a5.18163,5.18163,0,0,0,5.17578-5.17578v-1.59253a5.18168,5.18168,0,0,0-5.17578-5.17584H588.60951a5.18168,5.18168,0,0,0-5.17578,5.17584v1.59253a5.1649,5.1649,0,0,0,4.58105,5.11566L548.567,562.36828a24.49975,24.49975,0,0,0,21.89355,35.49585H622.9723A24.53865,24.53865,0,0,0,644.90736,562.32531Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M598.19629,501.63947,686.923,460.13812a5.57939,5.57939,0,0,1,7.4103,2.68719l4.97928,10.64537a5.58,5.58,0,0,1-2.68716,7.41057L607.89871,522.3826a5.57939,5.57939,0,0,1-7.4103-2.6872L595.50913,509.05a5.53525,5.53525,0,0,1-.18882-4.26106,5.60077,5.60077,0,0,1,.83054-1.51534A5.53833,5.53833,0,0,1,598.19629,501.63947Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ff4d4d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M595.15376,501.38368l39.063-23.2843a5.57925,5.57925,0,0,1,7.43669,2.60271l9.851,19.79134a5.57105,5.57105,0,0,1-2.63616,7.4514l-41.72869,16.1195c-1.09277.52569-3.238-.45819-4.96174-1.2487-.54047-.2479-1.00741-.46188-1.32643-.57352h0c-.14036-.04913-.27772-.10406-.41145-.16306a5.56337,5.56337,0,0,1-2.76831-2.682l-5.094-10.59095a5.59026,5.59026,0,0,1,.61369-5.83363A5.45945,5.45945,0,0,1,595.15376,501.38368Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M562.69652,398.23655a2.158,2.158,0,0,1-2.15088-2.15234,1.99593,1.99593,0,0,1,.05664-.50293L571.741,346.5178a2.1641,2.1641,0,0,1,3.57422-1.11181l36.92822,34.19629a2.16467,2.16467,0,0,1-.82128,3.65136L563.344,398.13939A2.22493,2.22493,0,0,1,562.69652,398.23655Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "141.465 153.383 118.269 148.767 118.634 147.156 139.141 151.233 141.465 153.383",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.73 170.303 115.38 161.478 115.745 159.859 157.405 168.144 159.73 170.303",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.864 178.738 140.535 179.767 112.499 174.188 112.864 172.569 143.864 178.738",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 183,
    r: 7,
    fill: "#ff4d4d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 5,
    r: 5,
    fill: "#ff6584"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 160,
    r: 5,
    fill: "#ff6584"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 143,
    r: 5,
    fill: "#ff4d4d"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 211,
    r: 5,
    fill: "#ff4d4d"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 225,
    r: 5,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 47,
    r: 5,
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M452.45251,315.96322a33.19778,33.19778,0,0,1,25.966,15.38081c.78611,1.25669,1.81231,2.63769,1.26813,4.18453a2.75118,2.75118,0,0,1-2.85064,1.90388,3.60537,3.60537,0,0,1-.37225-6.948c3.63116-1.5489,7.29467.84483,10.25248,2.75523,6.73958,4.353,14.1525,8.28974,22.319,8.78582,7.55589.45894,15.65843-2.50367,19.86115-9.05609.73527-1.14636-1.09032-2.20566-1.822-1.065-4.16807,6.49837-12.5941,8.8323-19.92043,7.82791a38.72628,38.72628,0,0,1-12.46469-4.23188c-2.01371-1.04505-3.96673-2.20352-5.88029-3.42131a37.52219,37.52219,0,0,0-5.76745-3.30626c-3.363-1.38148-7.81507-1.27356-10.16418,1.90709-2.19156,2.96734-.49786,7.90746,3.16765,8.74168a4.953,4.953,0,0,0,5.80209-5.89243c-.36573-1.7474-1.68153-3.45741-2.7-4.88568A35.31012,35.31012,0,0,0,452.4524,313.8532c-1.35727-.06714-1.35373,2.043,0,2.11Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M748.1641,379.83408a26.40376,26.40376,0,0,1-12.07126-20.747c-.05882-1.17748-.2362-2.53437.74132-3.3977a2.18814,2.18814,0,0,1,2.71775-.21725,2.86753,2.86753,0,0,1-2.4347,4.96965c-3.12222-.33183-4.73864-3.41434-6.0523-5.88762-2.99326-5.6356-6.61553-11.24307-12.09486-14.75316-5.06963-3.2476-11.8452-4.33084-17.30385-1.40929-.955.51112-.09775,1.95445.85252,1.44584,5.41365-2.89743,12.17018-1.25218,16.86895,2.28524a30.80089,30.80089,0,0,1,7.01628,7.77067c.99342,1.50634,1.90073,3.06794,2.75764,4.65543a29.84368,29.84368,0,0,0,2.72387,4.5318c1.80013,2.263,4.93387,3.91381,7.79822,2.61544a4.60646,4.60646,0,0,0,1.18859-7.29892,3.93937,3.93937,0,0,0-6.31359,1.84322,11.49183,11.49183,0,0,0-.01867,4.43969,28.08383,28.08383,0,0,0,12.80626,20.61941c.91659.57274,1.7321-.89415.8179-1.4654Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M575.62713,241.39217a26.40376,26.40376,0,0,1-20.652-12.2331c-.62523-.9995-1.44142-2.09788-1.0086-3.32815a2.18812,2.18812,0,0,1,2.26725-1.51424,2.86752,2.86752,0,0,1,.29607,5.52607c-2.888,1.23192-5.8018-.67193-8.15429-2.19136-5.36031-3.46217-11.25616-6.59322-17.7514-6.98778-6.00956-.365-12.4539,1.99129-15.79651,7.20274-.58481.91176.86718,1.75427,1.44908.847,3.31506-5.16846,10.01668-7.02475,15.84366-6.2259a30.80076,30.80076,0,0,1,9.91376,3.36581c1.6016.83118,3.15493,1.75256,4.67687,2.72113a29.8442,29.8442,0,0,0,4.58713,2.62963c2.6748,1.09875,6.2157,1.01292,8.08405-1.51681a4.60645,4.60645,0,0,0-2.51937-6.95267,3.93937,3.93937,0,0,0-4.61468,4.68653,11.4916,11.4916,0,0,0,2.14745,3.88582,28.08381,28.08381,0,0,0,21.23162,11.76345c1.0795.0534,1.07668-1.62493,0-1.67819Z",
    transform: "translate(-451.43578 -208.98655)",
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 85.57143,
    width: 5,
    height: 16.42857,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 492.16424,
    y: 267.57365,
    width: 4.91421,
    height: 16.1467,
    transform: "translate(587.84754 -88.1778) rotate(135)",
    fill: "#b3b3b3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 644.16424,
    y: 305.57365,
    width: 4.91421,
    height: 16.1467,
    transform: "translate(430.63399 783.6727) rotate(-135)",
    fill: "#b3b3b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 502.16424,
    y: 447.57365,
    width: 4.91421,
    height: 16.1467,
    transform: "translate(87.81566 925.6727) rotate(-135)",
    fill: "#ff6584"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.9e90d237229641ab9347ce87f20b7322.svg";
export { ForwardRef as ReactComponent };